import makeCachedSyncAPICall from './cachedSyncAPICall';
import smartSolveApi from './instances/smartsolve';

export const getTranslations = async (
  orgId,
  formKey,
  containerWorkflowKey,
  workflowKey,
  workflowId,
  stepId,
  entityType,
  certificationData,
  formSubEntityKey = '',
  itmId = '',
  forEdit = false,
  formId = ''
) => {
  try {
    const response = await smartSolveApi.post('/formelementtranslation', {
      orgId,
      formKey,
      containerWorkflowKey,
      workflowKey,
      workflowId,
      stepId,
      formEntityKey: entityType,
      certificationData,
      formSubEntityKey,
      itmId,
      forEdit,
      formId,
    });

    return response.data;
  } catch (e) {
    throw new Error(`getTranslations() failed: ${e}`);
  }
};

export const translateString = async (translationKey) => {
  try {
    const { data } = await smartSolveApi.post('/translation', {
      translationKey,
    });

    if (data.hasErrors) {
      throw new Error(`translateString() failed: ${data.errors}`);
    }

    return data;
  } catch (e) {
    throw new Error(`translateString() failed: ${e}`);
  }
};

export const bulkTranslateString = async (translationKeys) => {
  try {
    const { data } = await smartSolveApi.post('/translations', {
      keys: translationKeys,
    });

    if (data.hasErrors) {
      throw new Error(`bulkTranslateString() failed: ${data.errors}`);
    }

    return data;
  } catch (e) {
    throw new Error(`bulkTranslateString() failed: ${e}`);
  }
};

export const changeLanguage = async (language) => {
  try {
    const response = await smartSolveApi.post('/changelanguage', { language });

    return response.data;
  } catch (e) {
    throw new Error(`changelanguage() failed: ${e}`);
  }
};

const cachedGetTranslationSync = makeCachedSyncAPICall();

export const getTranslationSync = (params) => cachedGetTranslationSync('translation', params);

export const fetchSystemTranslations = async () => {
  try {
    const { data } = await smartSolveApi.post('/systemtranslation');
    if (data.hasErrors) {
      throw new Error(`fetchSystemTranslations() failed: ${data.errors}`);
    }
    return data.SystemTranslations;
  } catch (error) {
    throw new Error(`fetchSystemTranslations() failed: ${error}`);
  }
};

export const fetchOnDemandTranslation = async (stringtotranslate, language) => {
  try {
    const { data } = await smartSolveApi.post('/ondemandtranslation', {
      StringToTranslate: stringtotranslate,
      ToLanguage: language,
    });

    return data;
  } catch (e) {
    throw new Error(`fetchOnDemandTranslation() failed: ${e}`);
  }
};
